import React, {ReactElement} from 'react';
import {cx} from '@emotion/css';

import styles from './GrayLine.styles';

function GrayLine(): ReactElement {
  return (
    <div className={cx(styles.container)}>
      <hr className={cx(styles.line)} />
    </div>
  );
}

export default GrayLine;
